/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');
require('../plugins');

import Vue from 'vue';

import moment from 'moment';
Vue.prototype.moment = moment;

import store from './store/index'

window.Event = new class {
    constructor() {
        this.vue = new Vue();
    }

    fire(event, data = null) {
        this.vue.$emit(event, data);
    }

    listen(event, callback) {
        this.vue.$on(event, callback);
    }
}

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('validation-errors', require('../global/components/ValidationErrors.vue').default);
Vue.component('rebate-providers-modal-component', require('./components/RebateProvidersModalComponent.vue').default);
Vue.component('rebate-slider', require('./components/RebateSlider.vue').default);
Vue.component('homepage', require('./components/HomePage.vue').default);
Vue.component('rebate-form-component', require('./components/RebateFormComponent.vue').default);
Vue.component('rebate-status-modal-component', require('./components/RebateStatusModalComponent.vue').default);
Vue.component('file-management', require('./components/FileManagement.vue'));
Vue.component('attachment-list', require('./components/AttachmentList.vue'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    store,
    data: {

        loading: false,

        percent: null,

    },
    methods: {},
    created() {

        console.log('App created');

        Event.listen('percent', function(percent) {
            console.log('Received Upload Percent Status!');
            this.percent = percent;
        }.bind(this));

        Event.listen('loading_on', function() {
            console.log('Received Loading ON Event!');
            this.loading = true;
        }.bind(this));

        Event.listen('loading_off', function() {
            console.log('Received Loading OFF Event!');
            this.loading = false;
        }.bind(this));

    }
});